export const Subtitle = ({ text }) => {
  return (
    <p className="font-[400] text-[7px] md:text-sm lg:text-xl md:tracking-wide">
      {text}
    </p>
  );
};
